import { themeColor } from '@hud/web-components/theme/colors';
import { xxsRegular } from '@hud/web-components/theme/typography';
import styled from 'styled-components';

export const EndpointList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EndpointsLabel = styled.div`
  display: flex;
  height: 22px;
  width: fit-content;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  ${xxsRegular}
  text-decoration: none;

  border-radius: 6px;
  border: 1px solid ${themeColor('strokeSecondary')};
  background: ${themeColor('backgroundLight')};
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
  /* prevent line break */
  white-space: nowrap;
`;

export const APILabel = styled.span`
  color: ${themeColor('turquoise')};
`;
